import { checkLicenseFirstUse } from "src/api/editionCategory";
var _product_recommendedEntitlement;
/**
 * 이 상품에 쓸 이용 수단(이용권/구독)을 판정한다. 버튼 활성화·담기 요청이 모두 이 결과를 따른다.
 *
 * **`recommendedEntitlement` 만 본다.** `usableMembershipId` / `usableSubscriptionId` 는 보지 않는다.
 * - 둘 다 보유한 유저의 우선순위는 BE 정책이라, FE 가 두 id 를 보고 직접 고르면 정책이 새어 나온다
 * - 개별 id 는 담기(`use-as-membership`)의 커버리지 판정과 어긋나는 사례가 확인됐다.
 *   버튼은 켜지는데 담기가 403("has not a valid membership for this product") 으로 실패한다.
 *   `recommendedEntitlement` 가 담기와 같은 기준으로 계산된 필드다
 *
 * 따라서 이 필드가 없으면 쓸 수단이 없는 것으로 본다 (버튼 미노출).
 *
 * 사전 판정(`subscription-available` 등)은 하지 않는다. 이 필드 자체가 상품 단위 판정 결과라
 * 같은 판정을 리스트 아이템 수만큼 반복하게 될 뿐이고, 응답 이후 구독이 무효가 되는 경우는
 * 담기 요청의 `SUBSCRIPTION_EXPIRED` 403 으로 처리한다.
 */ export const getUsableEntitlement = (product)=>(_product_recommendedEntitlement = product.recommendedEntitlement) !== null && _product_recommendedEntitlement !== void 0 ? _product_recommendedEntitlement : null;
/**
 * 환불방어 다이얼로그(`LicenseUseDialog`)를 띄워야 하는지 — 이 이용 수단의 첫 사용인지 확인한다.
 *
 * 구독은 확인하지 않고 항상 `false`(= 띄우지 않음) 를 준다.
 * - `license-history` 는 `membershipId` 전용이라 구독 이력을 조회할 수단이 없다
 * - 다이얼로그의 환불 문구("이용 건당 5,000원 차감")는 단건 결제(이용권) 전제라
 *   구독에 그대로 띄우면 잘못된 고지가 된다
 * 구독 환불 정책이 확정되면 BE 에 구독용 이력 조회 수단을 요청해 이 분기를 되살릴 것.
 *
 * 조회 실패 시에는 첫 사용으로 간주해 띄운다 — 고지 누락이 환불 분쟁으로 이어지므로 보수적으로 처리한다.
 */ export const checkEntitlementFirstUse = async (entitlement)=>{
    if (entitlement.type === "subscription") return false;
    const { hasHistory  } = await checkLicenseFirstUse({
        membershipId: entitlement.id
    }).catch((error)=>{
        ;
        return {
            hasHistory: false
        };
    });
    return !hasHistory;
};
